import { Dashboard } from "./components/Dashboard";

export function App() {
  return <Dashboard />;
}
